'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsMarketing = require('./analytics-marketing.html');

var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);

var _analyticsMarketing3 = require('./analytics-marketing.controller');

var _analyticsMarketing4 = _interopRequireDefault(_analyticsMarketing3);

require('./analytics-marketing.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsMarketing2.default,
  controller: _analyticsMarketing4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-marketing/analytics-marketing.component.js
 **/